import type { AdminRecordPayload, AdminSession, LookupPayload, LookupResponse } from "../shared/types";

async function parseApiResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as T & { message?: string };
  if (!response.ok) {
    throw new Error(data.message || "ไม่สามารถเชื่อมต่อระบบได้");
  }
  return data;
}

export async function lookupPrivilege(payload: LookupPayload): Promise<LookupResponse> {
  const response = await fetch("/api/lookup", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return parseApiResponse<LookupResponse>(response);
}

export async function loginAdmin(username: string, password: string): Promise<AdminSession> {
  const response = await fetch("/api/admin/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await parseApiResponse<{ ok: boolean; session: AdminSession }>(response);
  return data.session;
}

export async function adminRequest<T>(
  token: string,
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${token}`);
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await fetch(`/api/admin/${path.replace(/^\//, "")}`, {
    ...init,
    headers,
  });
  return parseApiResponse<T>(response);
}

export function createRecord(token: string, payload: AdminRecordPayload) {
  return adminRequest<{ ok: boolean; record: unknown }>(token, "records", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
